<template>
  <RevCountryFlag
    v-if="market.countryCode"
    :country-code="market.countryCode"
    size="small"
  />
</template>

<script setup lang="ts">
import { useMarketplace } from '@backmarket/nuxt-module-marketplace/useMarketplace'
import { RevCountryFlag } from '@ds/components/CountryFlag'

const { market } = useMarketplace()
</script>
